<template>
  <div class="subtitle text-center">
    <div class="title font-weight-bold mx-8">{{event.name}}</div>
    <div v-if="event.details" ref="details" class="preserve-newlines">{{event.details}}</div>

    <div v-if="event.location || (!event.is_virtual && event.address) || event.url_map || event.url_virtual" class="mt-5">
      <div v-if="event.location" class="font-weight-bold">{{event.location}}</div>
      <div v-if="!event.is_virtual && event.address">{{event.address}}</div>
      <div v-if="event.url_map || event.url_virtual" class="mx-n2">
        <a v-if="event.url_map" class="ma-2" target="_blank" :href="event.url_map"><v-icon class="mr-1" x-small v-html="mdiMapMarker" />Map link</a>
        <a v-if="event.url_virtual" class="ma-2" target="_blank" :href="event.url_virtual">
          <v-icon class="mr-1" x-small v-html="mdiMonitorAccount" />Virtual event link
        </a>
      </div>
    </div>

    <div v-if="event.lz_date || event.lz_time_range || event.from" class="mt-5">
      <div v-if="event.lz_date" class="font-weight-bold">{{event.lz_date}}</div>
      <div v-if="event.lz_time_range">
        <span>{{event.lz_time_range}}</span>
        <span class="ml-1 text--label-active grey--text">{{event.lz_tz_name}}</span>
      </div>
      <a v-if="event.from" href="javascript:void(0)" @click="$emit('click-calendar')"><v-icon class="mr-1" x-small v-html="mdiCalendarPlus" />Add to calendar</a>
    </div>

    <div v-if="event.public_guest_list" class="mt-5">
      <div v-if="totals" class="font-weight-bold">Total attending: <template v-if="totalsLoading">…</template><template v-else>{{totals['Attending']}}<template v-if="event.form.separate_counts"> ({{totals['Adults']}} adult{{(totals['Adults'] == 1) ? '' : 's'}}, {{totals['Children']}} {{(totals['Children'] == 1) ? 'child' : 'children'}})</template></template></div>
      <a href="javascript:void(0)" @click="$emit('click-guest-list')"><v-icon class="mr-1" x-small v-html="mdiAccountGroup" />Show guest list</a>
    </div>
  </div>
</template>


<style scoped>
.title {
  line-height: 1.2em;
  color: rgba(0, 0, 0, 0.6);
}
.subtitle {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 20px;
}
</style>


<script>
import { mdiAccountGroup, mdiCalendarPlus, mdiMapMarker, mdiMonitorAccount } from '@mdi/js';

const LINK_REGEX = new RegExp(/(((ht|f)tps?:\/\/)|(\w[-+.%'~\w]*@))?([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/g);
const LINK_TLDS = new Set([ 'com', 'net', 'edu', 'org', 'gov', 'info', 'xyz', 'site', 'me', 'co', 'us', 'uk', 'au', 'nz', 'eu', 'io', 'ai' ]);

export default {
  name: 'event-summary',

  props: [ 'event', 'totals', 'totalsLoading' ],

  created() {
    Object.assign(this, { mdiAccountGroup, mdiCalendarPlus, mdiMapMarker, mdiMonitorAccount });
  },

  watch: {
    'event.details': {
      immediate: true,
      async handler(v) {
        if (v) {
          await this.$nextTick();

          // Note that we start from the innerText to automatically strip / escape any HTML
          const text = this.$refs.details.innerText;

          // TODO: this is largely taken from 'injectLinks' in the text-blob component, should be consolidated
          let match;
          let updated = '';
          let lastMatchEndI = 0;
          while (match = LINK_REGEX.exec(text)) {
            updated += text.substring(lastMatchEndI, match.index);
            if (match[0].startsWith('http')) {
              updated += `<a href="${match[0]}" target="_blank">${match[0]}</a>`;
            } else if (EMAIL_REGEX.test(match[0])) {
              updated += `<a href="mailto:${match[0]}" target="_blank">${match[0]}</a>`;
            } else {
              const tld = match[0].substring(match[0].lastIndexOf('.') + 1);
              if (LINK_TLDS.has(tld))
                updated += `<a href="http://${match[0]}" target="_blank">${match[0]}</a>`;
              else
                updated += match[0];
            }
            lastMatchEndI = match.index + match[0].length;
          }

          if (updated)
            this.$refs.details.innerHTML = updated + text.substring(lastMatchEndI);
        }
      }
    }
  }
}
</script>
